/**
 * Map a campaign (type + tags + config) to the correct admin editor preset.
 */
export type CampaignEditorKey =
  | 'spend_unlock_gift'
  | 'quantity_unlock_gift'
  | 'buy_x_get_y'
  | 'milestone_rewards'
  | 'generic';

export interface CampaignLike {
  type?: string;
  tags?: string[] | null;
  config?: Record<string, unknown> | null;
}

const PRESET_TAGS: CampaignEditorKey[] = [
  'spend_unlock_gift',
  'quantity_unlock_gift',
  'buy_x_get_y',
  'milestone_rewards',
];

export function resolveCampaignEditor(campaign: CampaignLike): CampaignEditorKey {
  const tags = (campaign.tags || []).map((t) => String(t).toLowerCase());

  for (const key of PRESET_TAGS) {
    if (tags.includes(key)) return key;
  }

  // Loose tag aliases
  if (tags.includes('bogo') || tags.includes('bxgy')) return 'buy_x_get_y';
  if (tags.includes('milestone') || tags.includes('cart_goal')) {
    return 'milestone_rewards';
  }

  const type = (campaign.type || '').toUpperCase();
  const config = (campaign.config || {}) as Record<string, unknown>;

  if (type === 'BUY_X_GET_Y') return 'buy_x_get_y';
  if (type === 'CART_GOAL' || type === 'MILESTONE') return 'milestone_rewards';

  if (type === 'FREE_GIFT') {
    const fg = (config.freeGift || {}) as {
      conditionType?: string;
      conditions?: { minQuantity?: number; minSubtotal?: number };
    };
    if (
      fg.conditionType === 'quantity' ||
      (fg.conditions?.minQuantity != null &&
        fg.conditions.minQuantity > 0 &&
        !fg.conditions.minSubtotal)
    ) {
      return 'quantity_unlock_gift';
    }
    return 'spend_unlock_gift';
  }

  return 'generic';
}

/** Path used when clicking Edit on the campaigns list */
export function campaignEditPath(campaign: {
  id: string;
  type?: string;
  tags?: string[] | null;
}): string {
  const key = resolveCampaignEditor(campaign);
  if (key === 'generic') return `/campaigns/${campaign.id}`;
  return `/campaigns/${campaign.id}?preset=${encodeURIComponent(key)}`;
}
